<script setup lang="ts">
import { FontAwesomeIcon } from '@shared/plugin/icons';

type Variant = keyof typeof colorClasses;

const props = withDefaults(defineProps<{ variant?: Variant; padding?: boolean }>(), {
  variant: 'primary',
  padding: true,
});

const colorClasses = {
  danger: 'text-secondary',
  primary: 'text-primary',
  white: 'text-white',
} as const satisfies Record<string, string>;
</script>

<template>
  <div
    class="inline-flex"
    :class="{
      'px-2 py-3': props.padding,
    }"
  >
    <FontAwesomeIcon
      :class="['animation-duration-700', colorClasses[props.variant]]"
      :icon="['fad', 'spinner-third']"
      spin
    />
  </div>
</template>
